
module.exports = {
  init: async function(parent,settings){
    this._parent=parent;
    this._settings=settings;
    this._has_post_rendered=false;
    this._ref_card_noresults=false;
    this._has_refreshed = false;
    this._scroll_to_top_element=false;
    this._slide_number=0;
    this._after_render = function(){};
    this._start_date = new Date();
    this._start_date=new Date(this._start_date.getFullYear(),this._start_date.getMonth()-1,this._start_date.getDate()).getTime()/1000;
    this._update_count=0;
    console.debug('dsb-list(coverflow): Init',this._start_date);
    this._postid_to_cardid={};
   },
   get_list_count: function(){
     let number = 0
     if(!this._ref_card_noresults)
     {
       number = this._parent._contentElements.list.childNodes.length;
       if(isNaN(number))
       {
         number = 0;
       }
     }
     console.error('get_list_count',number,this._parent._contentElements.list.getElementsByTagName('li'),this._parent._contentElements.list);
     return number;
  },
   pre_render: async function(DATA){
        console.debug('dsb-list(coverflow): pre_render');
        let _this = this;

        //Setup hide all posts
        this.hide_all_posts=function(){
           _this._parent._log('debug','coverflow.pre_render','coverflow_actions:hide_all_posts,');
          let list = _this._parent._contentElements.list.querySelectorAll(".coverflow_post");
          if(list !== undefined || list.length > 0)
          {
            for(let i = 0; i < list.length; i++)
            {
              list[i].style.display='none';
            }
          }

          list = _this._parent._contentElements.list.querySelectorAll(".coverflow_slidedownbutton");
          if(list !== undefined || list.length > 0)
          {
            for(let i = 0; i < list.length; i++)
            {
              list[i].style.display='inline-block';
            }
          }
        }

        this.display_dir='LTR';
        // Add step progress bar
        this.progress_steps_component = document.createElement("dsb-stepbar");
        let progress_steps_settings = {'active_color':'#fcdc18','default_color':'#000','complete_color':'green','size':'10px','progress_mode':'stage'};
        if((`add_order` in _this._parent.settings) && _this._parent.settings.add_order == 'prepend')
        {
           progress_steps_settings['add_order']='prepend';
           this.display_dir='RTL';
        }
        else
        {
          progress_steps_settings['add_order']='append';
        }
        this.progress_steps_component.setAttribute(`settings`, JSON.stringify(progress_steps_settings));
        this.progress_steps_component.setHeader(function(header,data){

          let text = header.querySelector("[data-stepbar='stats']");
          if(!(text instanceof HTMLElement))
          {
            text = document.createElement("span");
            text.setAttribute('data-stepbar','stats');
            text.style.display="inline-block";
            header.append(text);
          }
          let test_message = data.count+'/'+data.total+' of today\'s articles read';

          if(data.total==0)
          {
            text.innerHTML = '';
          }
          else
          {
            text.innerHTML =  test_message;
          }

          let countdown = header.querySelector("[data-stepbar='countdown']");
          if(!(countdown instanceof HTMLElement))
          {
            countdown = document.createElement("span");
            countdown.style.display='block';
            countdown.id="coverflow_countdown-"+_this._parent._createUUID();
            countdown.setAttribute('data-stepbar','countdown');
            countdown.innerHTML='...';
            header.append(countdown);
            let update_countdown=function(){
              var toDate=new Date();
              var tomorrow=new Date();
              tomorrow.setHours(24,0,0,0);
              var diffMS=tomorrow.getTime()/1000-toDate.getTime()/1000;
              var diffHr=Math.floor(diffMS/3600);
              diffMS=diffMS-diffHr*3600;
              var diffMi=Math.floor(diffMS/60);
              diffMS=diffMS-diffMi*60;
              var diffS=Math.floor(diffMS);
              var result=((diffHr<10)?""+diffHr:diffHr);
              result+=" hours "+((diffMi<10)?"0"+diffMi:diffMi);
              result+=" minutes until daily reset";
              countdown.innerHTML=result;

              let currentDate = new Date();
              currentDate=new Date(currentDate.getFullYear(),currentDate.getMonth()-1,currentDate.getDate()).getTime()/1000;

              if(!isNaN(_this._start_date) && !isNaN(currentDate))
              {
                if((_this._start_date < currentDate) && !_this._has_refreshed)
                {
                  console.debug('dsb-list(coverflow): refreshing...('+_this._start_date+' < '+currentDate+')');
                  _this.user_status('clear')
                  window.dispatchEvent(new CustomEvent('fw-pwa-serviceworker_action', {detail: {type:'purge_pages'}}));

                  // Wait 5 seconds then repopulate
                  setInterval(function(){
                    _this._has_refreshed = true;
                    _this._parent._refresh();
                  },5000);
                }

                _this._update_count++;

                if(_this._update_count >= 5)
                {
                  console.debug('dsb-list(coverflow): updating...');
                  _this._update_count = 0;
                  _this._parent._update();
                }
              }

            }
            update_countdown();
            setInterval(function(){
              update_countdown();
            },60000);
          }


        });
        _this._parent._contentElements.top.append(this.progress_steps_component);

        // Add complete step
        /**
        let _tmp_message={};
        _tmp_message.type="coverflow_complete_message";
        _tmp_message.title="All done! Come back tomorrow for more";
        if(`coverflow_complete_message` in _this._parent.settings)
        {
          _tmp_message.title=_this._parent.settings.coverflow_complete_message;
        }
        DATA.push(_tmp_message);
        */
        // Enable swipe
        //_this._contentElements.list


   },
   _log(type,source,message,data='')
   {
      this._parent._log(type,'coverflow.'+source,message,data);
   },
   post_render: async function(DATA){
      if(!this._has_post_rendered)
      {
        this._has_post_rendered=true;
        console.debug('dsb-list(coverflow): post_render');
        let _this = this;

        if(this._parent._contentElements.bottom instanceof HTMLElement)
        {
          this._scroll_to_top_element = document.createElement("span");
          this._scroll_to_top_element.classList.add('m-icon-up');
          this._scroll_to_top_element.classList.add('icon-clickable');
          /**
          this._scroll_to_top_element.onmouseover=function(){
            if(!this.classList.contains('hover'))
            {
              this.classList.add('hover');
            }
          };
          this._scroll_to_top_element.onmouseout=function(){
            if(this.classList.contains('hover'))
            {
              this.classList.remove('hover');
            }
          };
          */
          this._scroll_to_top_element.style="display:none;opacity:0;font-size: 3em; position: fixed; bottom: 10px; right: 10px; text-align: center;vertical-align: middle;";
          this._scroll_to_top_element.onclick = function(e){
            let workspace = window.getWorkspace(_this._parent);
            if(('fw_workbench' in window) && ('smoothScroll' in window.fw_workbench))
            {
              window.fw_workbench.smoothScroll(workspace);
            }
          }
          this._parent._contentElements.bottom.append(this._scroll_to_top_element);
        }

        if(this._parent._contentElements.list instanceof HTMLElement)
        {
          this._parent._contentElements.middle.classList.add('swipe');
          this._swipe_handler(this._parent._contentElements.list);
          this._parent._contentElements.list.style.setProperty('--other-elements-height',this._parent._contentElements.top.offsetHeight+'px');

          if(this.display_dir=='RTL')
          {
            // Select 1st
            let last_card = parseInt(this._parent._contentElements.list.style.getPropertyValue('--n'));
            this._parent._contentElements.list.coverflow_select(0);
            _this.progress_steps_component.setStep('coverflow_card_'+last_card,'active',false);
          }
          else
          {
            // Select last
            let last_card = parseInt(this._parent._contentElements.list.style.getPropertyValue('--n'));
            this._parent._contentElements.list.coverflow_select(last_card-1);
            _this.progress_steps_component.setStep('coverflow_card_'+last_card,'active',false);
          }

          // Setup for read
          this.user_status('get_data').then(function(data) {
            for(let i = 0; i<data.length; i++)
            {
              if(data[i] in _this._postid_to_cardid)
              {
                _this.progress_steps_component.setStep(_this._postid_to_cardid[data[i]],'complete',false);
              }
            }
          });
          this._after_render=function(){
            if('coverflow_update' in _this._parent._contentElements.list && typeof _this._parent._contentElements.list.coverflow_update == 'function')
            {
              _this._parent._contentElements.list.coverflow_update();
              _this._parent._contentElements.list.coverflow_refresh_selected();
            }
          }
        }
        else
        {
          console.debug('dsb-list(coverflow): Swipe off - parent._contentElements.list is not HTMLElement');
        }
      }

   },
   _swipe_handler: function(_this)
   {
      console.debug('dsb-list(coverflow): Setting up swipe');
      try
      {
        let workspace = false;
        if('getWorkspace' in window)
        {
          workspace = window.getWorkspace(_this);
        }

        let _parent = this;
        let N = _this.children.length;
        console.debug('dsb-list(coverflow): N='+N,_this);
        let NF = 30;
        let TFN = {
          /* can remove these if not used*/
          'linear': function(k) { return k },
          'ease-in': function(k, e = 1.675) {
            return Math.pow(k, e)
          },
          'ease-out': function(k, e = 1.675) {
            return 1 - Math.pow(1 - k, e)
          },
          'ease-in-out': function(k) {
            return .5*(Math.sin((k - .5)*Math.PI) + 1)
          },
          'bounce-out': function(k, a = 2.75, b = 1.5) {
            return 1 - Math.pow(1 - k, a)*Math.abs(Math.cos(Math.pow(k, b)*(n + .5)*Math.PI))
          }
        };

        _this.coverflow_update = function()
        {
          size();
          N = _this.children.length;
          _this.style.setProperty('--n', N);
        }

        _this.coverflow_refresh_selected = function()
        {
          if(_parent.display_dir=='RTL')
          {
            i = i+1;
            _setPropertyI(i);

            console.error(x0,y0,swipeXlocked,refresh_data,awaiting_move);
            if(!swipeXlocked)
            {
              x0 = null;
              y0 = null;
              locked = false;
              refresh_data=false;
              swipeXlocked = false;
              awaiting_move = false;
            }
            console.error(x0,y0,swipeXlocked,refresh_data,awaiting_move);


            /**
            this.coverflow_select(i+1);
            _setPropertyI(i+1);
            let current_card_number=N-i;
            if(current_card_number<0)
            {
              current_card_number=0;
            }
            console.error('@coverflow_update',current_card_number,N,i);
            _parent.progress_steps_component.setStep('coverflow_card_'+current_card_number,'active',false);
            */
          }
        }


        let refresh_panel_target = window.getWorkspace(_parent._parent);
        if(!(refresh_panel_target instanceof HTMLElement))
        {
          refresh_panel_target = _this;
        }
        // Pulldown refresh
        let refresh_panel_id = _parent._parent._createUUID();
        let refresh_panel = document.createElement("div");
        refresh_panel.classList='pulldown-refresh hide';
        refresh_panel.id=refresh_panel_id;
        refresh_panel.style="display:none";
        refresh_panel.innerHTML = `<div class="content"><maa-spinner type="inline-small"></maa-spinner></div>`;
        refresh_panel_target.prepend(refresh_panel);

        let loadPulldown = async function()
        {
          if(!refresh_panel.classList.contains('show'))
          {
            console.debug('dsb-list(coverflow):loadPulldown: Refreshing...',this_panel);
            let this_panel = document.getElementById(refresh_panel_id);
            this_panel.style="";
            this_panel.classList='pulldown-refresh show';
            let _refresh = await _parent._parent._update();
            setInterval(function(){
              this_panel.classList='pulldown-refresh hide';
            },2000);
          }
          else
          {
            console.error('do nothing...');
          }
        };

        let getCard = function (e)
        {
          let aParent = e.parentNode;
          if(aParent != null && typeof aParent === 'object')
          {
            let card = aParent.querySelector('.card');
            if(card != null && typeof card === 'object')
            {
              return card;
            }
            return getCard(aParent);
          }
          return false;
        };

        let i = 0, x0 = null,x0_hold = null, y0 = null,locked = false,refresh_data=false, swipeXlocked = false, awaiting_move = false, w, ini, fin, rID = null, anf, n, _i, original_i;

        let locked_card = null;
        let last_scrollpercentage = null;
        let scroll_to_top = false;


        let is_coverflow_xlock_shown = false;
        _this.coverflow_xlock_shown = function()
        {
          if(!swipeXlocked)
          {
            swipeXlocked='shown';
            awaiting_move = true;
            locked = true;
            is_coverflow_xlock_shown=true;

            //refresh_data=false;
          }
        }
        _this.coverflow_select = function(new_i)
        {
          i = new_i;
          _setPropertyI(i);
          x0 = null;
          y0 = null;
          locked = false;
          refresh_data=false;
          swipeXlocked = false;
          awaiting_move = false;
          _this.coverflow_update();
        }

        let onstopAni = function(){
          let current_card_number = parseInt(_this.style.getPropertyValue('--i'));
          console.debug('dsb-list(coverflow): move/onstopAni - setting setStep active',_parent.progress_steps_component,current_card_number);

          if(!isNaN(current_card_number))
          {
            if(_parent.display_dir=='RTL')
            {
              current_card_number=N-current_card_number;
              if(current_card_number<0)
              {
                current_card_number=0;
              }
            }
            else
            {
              current_card_number=current_card_number+1;
            }
            _parent.progress_steps_component.setStep('coverflow_card_'+current_card_number,'active',false);
          }
          _parent.hide_all_posts();
        };

        function stopAni() {
          console.debug('dsb-list(coverflow): stopAni');
          cancelAnimationFrame(rID);
          rID = null;
          onstopAni();
        };

        function ani(cf = 0) {
          let new_i =  ini + (fin - ini)*TFN['ease-in-out'](cf/anf);

          if(cf==0 && anf==0 && isNaN(new_i))
          {
            // Ok skipping, just a click on a card
          }
          else
          {
          _setPropertyI(new_i);
          }

          console.debug('dsb-list(coverflow): ani',cf,anf,new_i);
          if(cf === anf) {
            stopAni();
            return
          }

          rID = requestAnimationFrame(ani.bind(this, ++cf))
        };

        function unify(e) {	return e.changedTouches ? e.changedTouches[0] : e };

        function lock(e) {

          awaiting_move = false;
          // Skip lock if clickable
          if(e.target instanceof HTMLElement && e.target.classList.contains('icon-clickable'))
          {
            return;
          }

          x0_hold = unify(e).clientX;

          if(!swipeXlocked)
          {
            x0 = unify(e).clientX;
            y0 = unify(e).clientY;
            locked = true;
          }
        };

        function _setPropertyI(i)
        {
          console.error('dsb-list(coverflow): Setting i to '+i);
          if(i==-1)
          {
            i=1;
          }
          _this.style.setProperty('--i',i);
        }

        function drag(e) {
          if(locked)
          {
            let card = getCard(e.target);
            if(!swipeXlocked && !awaiting_move)
            {
              e.preventDefault();
              original_i = _i;
              let dx = unify(e).clientX - x0, f = +(dx/w).toFixed(2);

              _i=i - f;

              // Check for vertical movement
              let Xdiff=Math.abs(x0-unify(e).clientX);
              let Ydiff=Math.abs(y0-unify(e).clientY);
              let _Ydiff=(y0-unify(e).clientY);
              console.debug('dsb-list(coverflow): '+x0+'/'+y0+' ['+unify(e).clientX+'/'+unify(e).clientY+'] - '+Ydiff+', id='+card.id,card);

              //if(Ydiff>40 && Ydiff>Xdiff)
              if(_Ydiff>40 && Xdiff<10)
              {
                console.debug('dsb-list(coverflow): Locking swipeX on '+card.id);
                //console.error('PULLDOWN','Locking swipeX',Ydiff,Xdiff,Math.abs(Ydiff),Math.abs(Xdiff));
                swipeXlocked=true;
                awaiting_move=true;
                let _new_i = Math.floor(original_i)*+1;
                //_this.style.setProperty('--i', (_new_i>0?_new_i:1));
                _setPropertyI(_new_i);
              }
              else
              {
                //console.error('PULLDOWN',_Ydiff,Ydiff,Xdiff);
                if(_Ydiff<-40 && Xdiff>-10 && Xdiff<10)
                {
                  refresh_data=true;
                }
                swipeXlocked=false;
                _setPropertyI(_i);
              }

            }
            else
            {
              if(workspace)
              {
                console.debug('dsb-list(coverflow): Looking at  workspace.scrollTop='+workspace.scrollTop);

                if(workspace.scrollTop < 10)
                {
                  let Xdiff = 0;
                  let unlock=false;
                  if(x0_hold>0)
                  {
                     Xdiff=Math.abs(x0_hold-unify(e).clientX);
                     x0=x0_hold;
                     console.debug('dsb-list(coverflow): Looking at  workspace.scrollTop(x0_hold)',x0_hold,unify(e).clientX,Xdiff);
                  }
                  else
                  {
                     console.debug('dsb-list(coverflow): Looking at  workspace.scrollTop(x0)',x0,unify(e).clientX,Xdiff);
                     Xdiff=(x0-unify(e).clientX)*+1;
                  }

                  if(Xdiff>40)
                  {
                    unlock=true;
                  }

                  //let Xdiff=Math.abs(x0-unify(e).clientX);

                  if(unlock)
                  {
                    console.debug('dsb-list(coverflow): UN-Locking swipeX on '+e.target.id);
                    // _this.style.setProperty('--i', Math.floor(original_i)*+1);
                    _setPropertyI(i);
                    _parent.hide_all_posts();
                    swipeXlocked=false;
                    awaiting_move=true;

                    scroll_to_top=false;
                    last_scrollpercentage=null;
                    _parent._scroll_to_top_element._view_state='';
                    _parent._scroll_to_top_element.style.display = 'none';
                    console.debug('dsb-list(coverflow): Resetting --i to '+i);
                  }
                  else
                  {
                    e.stopPropagation();
                  }
                }
                /**
                else
                {
                    // Check for vertical movement
                    let _Ydiff=(y0-unify(e).clientY);

                    console.error(_Ydiff,y0,unify(e).clientY);
                    if(y0<unify(e).clientY)
                    {
                      scroll_to_top=true;
                    }
                    else if(y0<unify(e).clientY)
                    {
                       scroll_to_top=false;
                      last_scrollpercentage=null;
                      _parent._scroll_to_top_element._view_state='';
                      _parent._scroll_to_top_element.style.display = 'none';
                    }
                }
                */
              }
              else
              {
               e.stopPropagation();
              }
            }
          }
        };

        function move(e) {
          if(locked) {

            if(swipeXlocked)
            {
              if(swipeXlocked!=='clicked' && swipeXlocked!=='shown')
              {
                let card_element = getCard(e.target);
                card_element.coverflow_actions('show_post');
                swipeXlocked='shown';
                let card_i = card_element.id;
                card_i=card_i.replace('coverflow_card_','');

                if(!isNaN(card_i))
                {
                  if(_parent.display_dir=='RTL')
                  {
                    card_i=N-card_i;
                  }
                  else
                  {
                    card_i=card_i-1;
                  }
                  if(card_i>=0)
                  {
                    _setPropertyI(card_i);
                  }
                }
                card_element.coverflow_actions('scroll_to_posttop');
              }

              let scroll_percentage = ((workspace.scrollTop/workspace.scrollHeight)*100);
              if(scroll_percentage > 10)
              {
                if(swipeXlocked!=='clicked')
                {
                  let card_element = getCard(e.target);
                  card_element.coverflow_actions('read_post');
                  locked_card = card_element;
                  swipeXlocked='clicked';
                }

                if(_parent._scroll_to_top_element && _parent._scroll_to_top_element instanceof HTMLElement)
                {
                  console.error('dsb-list(coverflow): Looking at _scroll_to_top_element',_parent._scroll_to_top_element._view_state,last_scrollpercentage, scroll_percentage,Math.abs(last_scrollpercentage-scroll_percentage));
                  if(last_scrollpercentage!=='locked' && _parent._scroll_to_top_element._view_state!=='shown')
                  {
                    console.error('@check',scroll_to_top,scroll_percentage);
                    if(last_scrollpercentage !== null && !isNaN(last_scrollpercentage) && (last_scrollpercentage>scroll_percentage))
                    {
                        scroll_to_top=true;
                    }
                    else
                    {
                       scroll_to_top=false;
                    }

                    if(scroll_to_top)
                    {
                       console.error('@locked',last_scrollpercentage,scroll_percentage);
                      last_scrollpercentage='locked';
                      let op_in =  _parent._scroll_to_top_element.style.opacity;  // initial opacity
                      if(op_in == 0)
                      {
                        op_in = 0.1;
                      }
                      let _scroll_to_top_element_timer_in = setInterval(function () {
                          if (op_in >= 1 || isNaN(op_in)){
                              console.error('@shown, wait 5');
                              clearInterval(_scroll_to_top_element_timer_in);
                              _parent._scroll_to_top_element.style.opacity = 1;
                              _parent._scroll_to_top_element.style.filter = 'alpha(opacity=' + (1 * 100) + ")";
                              let op_out=1;
                              setTimeout(function(){
                                  let _scroll_to_top_element_timer_out = setInterval(function () {
                                    if (op_out <= 0.1 || isNaN(op_out)){
                                        console.error('@hidden');
                                        clearInterval(_scroll_to_top_element_timer_out);
                                        _parent._scroll_to_top_element.style.display = 'none';
                                        _parent._scroll_to_top_element._view_state='shown';
                                        _parent._scroll_to_top_element.style.opacity = 0;
                                        _parent._scroll_to_top_element.style.filter = 'alpha(opacity=' + (0 * 100) + ")";
                                    }
                                    else
                                    {
                                      console.error('@hiding',op_out);
                                      _parent._scroll_to_top_element.style.opacity = op_out;
                                      _parent._scroll_to_top_element.style.filter = 'alpha(opacity=' + (parseFloat(op_out) * 100) + ")";
                                      op_out -= parseFloat(op_out) * 0.1;
                                    }
                                }, 50);
                              },5000);
                          }
                          _parent._scroll_to_top_element.style.display = 'block';
                          console.error('@showing',op_in);
                          _parent._scroll_to_top_element.style.opacity = op_in;
                          _parent._scroll_to_top_element.style.filter = 'alpha(opacity=' + (parseFloat(op_in) * 100) + ")";
                          op_in += parseFloat(op_in) * 0.1;
                      }, 10);
                    }
                    else
                    {
                      last_scrollpercentage=scroll_percentage;
                    }
                  }
                  else
                  {
                    if(scroll_percentage<=1)
                    {
                      console.error('@forcehide',scroll_percentage);
                      _parent._scroll_to_top_element.style.display = 'none';
                      scroll_to_top=false;
                    }

                    if(_parent._scroll_to_top_element._view_state=='shown')
                    {
                      console.error('@skip',last_scrollpercentage,scroll_percentage,Math.abs(last_scrollpercentage-scroll_percentage));
                      if(last_scrollpercentage<scroll_percentage && Math.abs(last_scrollpercentage-scroll_percentage) > 2)
                      {
                        scroll_to_top=true;
                      }
                      last_scrollpercentage=scroll_percentage;
                    }
                  }
                }
              }
              e.stopPropagation();
            }
            else
            {
              e.stopPropagation()
              e.preventDefault();
              let dx = unify(e).clientX - x0,
                  s = Math.sign(dx),
                  f = +(s*dx/w).toFixed(2);

              ini = i - s*f;

              if((i > 0 || s < 0) && (i < N - 1 || s > 0) && f > .2) {
                i -= s;
                f = 1 - f
              }

              fin = i;
              anf = Math.round(f*NF);
              n = 2 + Math.round(f)
              ani();
              x0 = null;
              locked = false;
              locked_card=null;
            }
            awaiting_move=false;

            // Refresh data
            if(refresh_data)
            {
              // Force onto one card
              let card_i = getCard(e.target).id;
              card_i=card_i.replace('coverflow_card_','');
              if(!isNaN(card_i))
              {
                if(_parent.display_dir=='RTL')
                {
                  card_i=N-card_i;
                }
                else
                {
                  card_i=card_i-1;
                }

                if(card_i>=0)
                {
                  _setPropertyI(card_i);
                }
              }
              loadPulldown();
              refresh_data=false;
              swipeXlocked=false;
              awaiting_move=true;
            }
          }
        };

        function size() { w = window.innerWidth };

        _this.coverflow_update();

        addEventListener('resize', size, false);

        _this.addEventListener('mousedown', lock, false);
        _this.addEventListener('touchstart', lock, false);

        _this.addEventListener('mousemove', drag, false);
        _this.addEventListener('touchmove', drag, false);

        _this.addEventListener('mouseup', move, false);
        _this.addEventListener('touchend', move, false);

        let observeTarget = new MutationObserver(function (e) {
          _this.coverflow_update();
        });
        observeTarget.observe(_this, { childList: true });
      }
      catch(ex)
      {
        console.error('dsb-list(coverflow): _swipe_handler',ex);
      }

   },
   user_status: async function(task,id=false)
   {
      if(this._parent.dsbClient.user.has_localdb())
      {
        try
        {

          let new_data = {
            'id':'coverflow_today',
            'status':'published',
            'data':[]
          }

          switch(task)
          {
            case "get_data":
              let current_data = await this._parent.dsbClient.user.get('local','id=coverflow_today');
              if(typeof current_data === 'object' && 'data' in current_data)
              {
                return current_data.data;
              }
              else
              {
                return [];
              }
              return
              break;
            case "update":
              if(id && !(isNaN(id)))
              {
                let current_data = await this._parent.dsbClient.user.get('local','id=coverflow_today');
                this._log('debug','handle_read_status',current_data);
                if(!current_data)
                {
                  current_data = new_data;
                }

                if(!('expirationdate' in current_data) || !current_data.expirationdate)
                {
                  let currentDate = new Date();
                  current_data.expirationdate = new Date(currentDate.getFullYear(),currentDate.getMonth()-1,currentDate.getDate()+1).getTime()/1000
                }
                if(current_data.data.indexOf(id)<0)
                {
                  current_data.data.push(id);
                }
                return await this._parent.dsbClient.user.post('local',current_data);
              }
              else
              {
                throw "Id is not a number";
              }
              break;
            case "clear":
              return await this._parent.dsbClient.user.post('local',new_data);
          }
        }
        catch(ex)
        {
            this._log('error','handle_read_status','Thrown error for task='+task+'; id='+id,ex);
            return false;
        }
      }
   },
   render: async function(LIST_POSITION,CURRENT_DATA,ITEM,ITEM_SETTINGS) {
      console.debug('dsb-list(coverflow): render');
      let _this = this;
      _this._parent.classList.add('coverflow');

      let service = _this._parent.dsbClient.content.default_service;

      ITEM.classList.add('item');

      let card_element = document.createElement("div");
      card_element.classList.add('card');

      if(LIST_POSITION==1)
      {
        //ITEM.classList.add('active');
      }

      let item_title = document.createElement("h2");

      if("no-results" == CURRENT_DATA.type)
      {
        item_title.innerHTML = 'Nothing yet today...';
        item_title.style.width="100%";
        item_title.style.textAlign="center";
        card_element.id='coverflow_card_noresults';
        card_element.append(item_title);
        let item_icon = document.createElement("span");
        item_icon.style="display:block;text-align:center;font-size:200px";
        item_icon.classList.add("icon-schedule");
        item_title.prepend(item_icon);
        ITEM.append(card_element);
        this._ref_card_noresults=card_element;
      }
      else
      {

        if(this._ref_card_noresults)
        {
          this._ref_card_noresults.remove();
          this._ref_card_noresults=false;
        }

        if('title' in CURRENT_DATA)
        {
          //item_title.innerHTML = LIST_POSITION+'@'+CURRENT_DATA.title;
          item_title.innerHTML = CURRENT_DATA.title;
          card_element.id='coverflow_card_'+LIST_POSITION;
        }
        else
        {
          console.error('Unknown title');
        }

        if("section" == CURRENT_DATA.type)
        {
          service = 'static';
          item_title.style.textAlign='center';
        }

        let advertiser_logo = null;

        if('author' in CURRENT_DATA)
        {
          if('type' in CURRENT_DATA.author)
          {
            switch(CURRENT_DATA.author.type)
            {
              case "advert":
                  let advertiser_logo_img = this._parent.dsbClient.content.applyFilter(`formatData_lookup`, [ `author_advertiser_logo`, CURRENT_DATA.author.id ] );
                  if(advertiser_logo_img)
                  {
                    advertiser_logo = document.createElement("div");
                    advertiser_logo.classList.add('advertiser-logo');
                    advertiser_logo.setAttribute('style','background-image:url('+advertiser_logo_img+')');
                    advertiser_logo.classList.add('circle-image');
                  }
                  break;
              default:
                  break;
            }
          }
        }

        // Background images
        if('show-thumbnail' in ITEM_SETTINGS)
        {
          switch(ITEM_SETTINGS['show-thumbnail'])
          {
              case "top":
                  let content_block = document.createElement("div");
                  content_block.classList.add('content-block');
                  content_block.append(item_title);
                  card_element.classList.add(`layout-image-top`);

                  if('images' in CURRENT_DATA)
                  {
                    if('large' in CURRENT_DATA.images)
                    {
                      let content_thumbnail = document.createElement("div");
                      content_thumbnail.classList.add('content-thumbnail');
                      if(CURRENT_DATA.images.large.endsWith('.svg'))
                      {
                        content_thumbnail.setAttribute('style', 'background-image:url('+CURRENT_DATA.images.large+');background-size: auto 100%;background-position: top;');
                      }
                      else
                      {
                        //content_thumbnail.setAttribute('style', 'background-image:linear-gradient( to top, transparent 70%, #353535 ),url('+CURRENT_DATA.images.large+')');
                        content_thumbnail.setAttribute('style', 'background-image:url('+CURRENT_DATA.images.large+')');

                      }
                      card_element.append(content_thumbnail);
                      if(advertiser_logo != null && typeof advertiser_logo === 'object' && advertiser_logo instanceof HTMLElement)
                      {
                        content_block.append(advertiser_logo);
                      }
                      //this._settings.imageObserver.observe(ITEM);
                    }
                  }
                   card_element.append(content_block);
                  break;
              case "background":
                  card_element.append(item_title);
                  if('images' in CURRENT_DATA)
                  {
                    if('large' in CURRENT_DATA.images)
                    {
                      card_element.classList.add(`layout-image-background`);
                      let overlay_bottom = document.createElement("span");
                      overlay_bottom.classList.add('overlay-bottom');
                      card_element.append(overlay_bottom);
                      let overlay_top = document.createElement("span");
                      overlay_top.classList.add('overlay-top');
                      card_element.append(overlay_top);
                      card_element.setAttribute('style', 'background-image:url('+CURRENT_DATA.images.large+')');
                      //this._settings.imageObserver.observe(ITEM);
                      if(advertiser_logo != null && typeof advertiser_logo === 'object' && advertiser_logo instanceof HTMLElement)
                      {
                        card_element.append(advertiser_logo);
                      }
                    }
                  }
                  break;
              case "icon":
                  if('icon' in CURRENT_DATA)
                  {
                    let content_block = document.createElement("div");
                    content_block.classList.add('content-block');
                    let item_icon = document.createElement("span");
                    item_icon.classList.add(CURRENT_DATA.icon);
                    item_icon.style.height="";
                    content_block.append(item_icon);
                    content_block.append(item_title);
                    card_element.classList.add(`layout-icon`);
                    card_element.append(content_block);
                  }
                  break;
              default:
                  console.error(ITEM_SETTINGS['show-thumbnail']+' not supported in coverflow');
                  card_element.classList.add(`layout-no-image`);
                  card_element.append(item_title);
                  if(advertiser_logo != null && typeof advertiser_logo === 'object' && advertiser_logo instanceof HTMLElement)
                  {
                    card_element.append(advertiser_logo);
                  }
                  break;
          }
        }

        ITEM.id="coverflow_"+CURRENT_DATA.id;
        this.progress_steps_component.setStep(card_element.id,'');
        this.progress_steps_component.setStep(card_element.id,(LIST_POSITION==1?'active':''),true,
          function(){
            let card_id = this.getAttribute('alt');
            card_id=parseInt(card_id.replace('coverflow_card_',''));
            if(_this.display_dir=='RTL')
            {
              _this._parent._contentElements.list.coverflow_select(parseInt(_this._parent._contentElements.list.style.getPropertyValue('--n'))-card_id);
            }
            else
            {
              _this._parent._contentElements.list.coverflow_select(card_id-1);
            }
            _this.progress_steps_component.setStep('coverflow_card_'+card_id,'active',false);
          }
        );
        this._postid_to_cardid[CURRENT_DATA.id]=card_element.id;

        let coverflow_component = document.createElement("dsb-post");
        coverflow_component.setDSBClient(_this._parent.dsbClient);
        coverflow_component.setAttribute(`service`, service);
        coverflow_component.setAttribute('post_id', CURRENT_DATA.id);
        coverflow_component.setAttribute(`settings`, JSON.stringify({'base_update':'off','header':'off','clean_body':'on','page_view_onload':'off','pulldown_refresh':'off','lazy_images':'off'}));
        coverflow_component.innerHTML = `<maa-spinner></maa-spinner>`;
        coverflow_component.style.display='none';
        coverflow_component.style.width='var(--fullwidth)';
        coverflow_component.style.position='relative';
        coverflow_component.classList.add('coverflow_post');

        card_element.coverflow_actions=function(action)
        {
            switch(action)
            {
              case "show_post":
                   _this._parent._log('debug','coverflow.render','coverflow_actions:show_post,',coverflow_component);
                  _this.hide_all_posts();
                  coverflow_component.style.display='inline-block';
                  coverflow_slidedownbutton.style.display='none';
                  break;
              case "scroll_to_posttop":
                  _this._parent._log('debug','coverflow.render','coverflow_actions:scroll_to_top,',coverflow_component);
                  let workspace = window.getWorkspace(_this._parent);
                  if(('fw_workbench' in window) && ('smoothScroll' in window.fw_workbench) && ('getAppStyleProperties' in window.fw_workbench))
                  {
                    let scroll_to = parseInt(coverflow_component.getBoundingClientRect().top)-parseInt(window.fw_workbench.getAppStyleProperties('header','height').replace('px',''))-parseInt(getComputedStyle(document.documentElement).getPropertyValue("--safe-top"));
                    window.fw_workbench.smoothScroll(workspace,scroll_to);
                  }
                  break;
              case "read_post":
                    _this._parent._log('debug','coverflow.render','coverflow_actions:read_post,',coverflow_component);
                    _this.user_status('update',coverflow_component.getAttribute('post_id')).then(function(data) {
                      coverflow_component.page_view();
                      _this.progress_steps_component.setStep(card_element.id,'complete');
                    });
                    /**
                   _this._parent.dsbClient.user.post('readprogress',{"id":coverflow_component.getAttribute('post_id'),"status":"read","source":"coverflow_today"},true).then(function(data) {
                    coverflow_component.page_view();
                    _this.progress_steps_component.setStep(card_element.id,'complete');
                    _this.handle_read_status('record',coverflow_component.getAttribute('post_id'));
                  });
                  */
                break;
              default:
                  break;
            }

        };

        let coverflow_slidedownbutton = document.createElement("span");
        coverflow_slidedownbutton.classList.add('m-icon-down');
        coverflow_slidedownbutton.classList.add('icon-clickable');
        coverflow_slidedownbutton.classList.add('coverflow_slidedownbutton');
        coverflow_slidedownbutton.style="font-size: 3em; position: absolute; bottom: 0px; right: 1px; z-index: 1;width: 100%;text-align: center;vertical-align: middle;";
        coverflow_slidedownbutton.onclick = function(e){
          card_element.coverflow_actions('show_post');
          _this._parent._contentElements.list.coverflow_xlock_shown();
          card_element.coverflow_actions('scroll_to_posttop');
        }
        card_element.append(coverflow_slidedownbutton);

        ITEM.append(card_element);

        let coverflow_nav_slideupbutton = document.createElement("span");
        coverflow_nav_slideupbutton.classList.add('m-icon-up');
        coverflow_nav_slideupbutton.classList.add('icon-clickable');
        coverflow_nav_slideupbutton.style="padding:5px;font-size:3em;font-color:#fff;background-color:#5a5a5a;text-align:middle;position:absolute;bottom:10px;right:1px;";
        coverflow_nav_slideupbutton.onclick = function(){
          let workspace = window.getWorkspace(_this._parent);
          if(('fw_workbench' in window) && ('smoothScroll' in window.fw_workbench))
          {
            window.fw_workbench.smoothScroll(workspace);
          }
        }


        let coverflow_nav_nextbutton = document.createElement("span");
        coverflow_nav_nextbutton.classList.add('m-icon-right');
        coverflow_nav_nextbutton.classList.add('icon-clickable');
        coverflow_nav_nextbutton.style="padding:5px;font-size:3em;font-color:#fff;background-color:#5a5a5a;text-align:middle;position:absolute;bottom:10px;left:1px;";
        coverflow_nav_nextbutton.onclick = function(){
          let workspace = window.getWorkspace(_this._parent);
-          workspace.scroll({
            top: 0,
            behavior: "smooth"
          });
          let li = _this._parent._contentElements.list.querySelectorAll("li");
          let next = false;
          if(li !== undefined || li.length > 0)
          {
            for(let i = 0; i < li.length; i++)
            {
              if(next)
              {
                next=false;
                li[i].classList.add('active');
                this._parent._contentElements.list.style.setProperty('--i',i);
                this.progress_steps_component.setStep(li[i].id,'active');

              }
              else if(li[i].classList.contains('active'))
              {
                li[i].classList.remove('active');
              }

              if(li[i].id == ITEM.id)
              {
                next=true;
                this.progress_steps_component.setStep(li[i].id,'complete',false);
              }
            }
          }
        }

        let coverflow_nav = document.createElement("div");
        coverflow_nav.style="position:relative;height:calc(10px + 3em);"
        //coverflow_nav.append(coverflow_nav_nextbutton);
        coverflow_nav.append(coverflow_nav_slideupbutton);
        coverflow_component.appendContent(coverflow_nav);
        ITEM.append(coverflow_component);
        _this._after_render();
      }
   }
}
